import { render, staticRenderFns } from "./BasePageTemplate.vue?vue&type=template&id=46fa3c49&scoped=true&"
import script from "./BasePageTemplate.vue?vue&type=script&lang=js&"
export * from "./BasePageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BasePageTemplate.vue?vue&type=style&index=0&id=46fa3c49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa3c49",
  null
  
)

export default component.exports